import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  span {
    color: #008fab;
    font-size: 1rem;
    margin-right: 0.25rem;
  }
  p {
    margin-left: 0.5rem;
    margin-bottom: 0;
    color: #008fab;
    height: 20px !important;
  }

  .stars {
    display: flex;
  }

  .starClass {
    height: 20px !important;
    width: 20px !important;
  }
`;

export default Wrapper;
